import type { WorkspacesDataSlice } from './workspaces.type'

export const workspacesInitialState: WorkspacesDataSlice = {
  workspaces: [],
  currentWorkspace: null,
  loading: false,
  error: null,
  createProjectForWorkspaceId: null,
  isCreatingWorkspace: false,
  userWorkspacesFetched: false,
}
